import { Component, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketService } from '../../../core/services/ticket.service';
import { TicketSolution } from '../../../core/models/ticket.model';
import { Subscription } from 'rxjs';
import { TicketFormComponent } from './ticket-form/ticket-form.component';
import { SolutionSidebarComponent } from './solution-sidebar/solution-sidebar.component';
import { CreateTicketData } from './models/create-ticket.model';
import { LogoutComponent } from '@app/features/logout/logout.component';

@Component({
  selector: 'app-create-ticket',
  standalone: true,
  imports: [CommonModule, TicketFormComponent, SolutionSidebarComponent, LogoutComponent],
  template: `
    <div class="max-w-7xl mx-auto py-4 sm:py-6 px-4 sm:px-6 lg:px-8 relative">
      <div class="absolute top-4 right-4 sm:top-6 sm:right-6 z-50">
        <app-logout></app-logout>
      </div>

      <div class="py-4 sm:py-6 sm:px-0">
        <app-ticket-form (submitTicket)="onSubmitTicket($event)"></app-ticket-form>
        <app-solution-sidebar
          [solution]="solution"
          [ticketTitle]="currentTicketData?.title || ''"
          [ticketDescription]="currentTicketData?.description || ''"
          [ticketPriority]="currentTicketData?.priority || ''"
          (accept)="acceptSolution()"
          (reject)="rejectSolution()"
        >
        </app-solution-sidebar>
      </div>
    </div>
  `,
})
export class CreateTicketComponent implements OnDestroy {
  @ViewChild(TicketFormComponent) ticketForm!: TicketFormComponent;
  solution: TicketSolution | null = null;
  currentTicketId: string | null = null;
  currentTicketData: CreateTicketData | null = null;
  private subscription = new Subscription();

  constructor(private ticketService: TicketService) {}

  onSubmitTicket(formData: CreateTicketData): void {
    // Store the ticket data for feedback submission
    this.currentTicketData = formData;
    
    this.subscription.add(
      this.ticketService
        .createTicket({
          ...formData,
          status: 'open',
          userId: 'default-user-id',
          application: formData.application as 'SFDC_CRM' | 'SDP' | 'ERP_MRP' | 'OM',
          priority: formData.priority as 'low' | 'medium' | 'high',
        })
        .subscribe((ticket) => {
          if (ticket.id) {
            this.currentTicketId = ticket.id;
            this.ticketService
              .getSolutionSuggestion(ticket)
              .subscribe((solution) => (this.solution = solution));
          }
        })
    );
  }

  acceptSolution(): void {
    if (this.currentTicketId) {
      this.subscription.add(
        this.ticketService.closeTicket(this.currentTicketId).subscribe(() => {
          this.solution = null;
          this.ticketForm.reset();
          this.currentTicketId = null;
          this.currentTicketData = null;
        })
      );
    }
  }

  rejectSolution(): void {
    this.solution = null;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
